import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import FormLayout from 'shared/components/forms/FormLayout';
import Input from 'shared/components/Input';
import Select2 from 'shared/components/Select2';
import CheckboxWithLabel from 'shared/components/CheckboxWithLabel';
import LabelHelper from 'shared/components/LabelHelper';
import FormError from 'shared/components/FormError';
import {LexicalEditor} from 'main/components';
import QuestionTypeFormFactory from 'main/components/forms/question/components/QuestionTypeFormFactory';

const QuestionForm = observer((props) => {
  const {question, questionTypes, localization, showRequired, showDescription, showQuestionType, errorMessage, ...rest} = props;

  return (
    <FormLayout>
      <Input
        label={localization.question}
        placeholder={localization.question}
        value={question.questionName}
        onChange={e => question.updateText(e.target.value)} />
      {showDescription && <div>
        <LabelHelper label={t(localization.description)} />
        <LexicalEditor
          placeholder={'recruiting.edit.steps.Add a description...'}
          onChange={description => question.merge({lexicalState: description.state, description: description.html})}
          initialEditorState={question.lexicalState}
          initialHTML={question.description}
          disableHeaders
          inModal
        />
      </div>}
      {(question.isNew && showQuestionType) && <Select2
        label={localization.questionType}
        value={question.questionType}
        onChange={e => {question.args = {options: []}; question.merge({questionType: e.target.value});}}>
          {questionTypes.map(type =>
            <option value={type} key={type}>
              {t(`components.question_form.question_types.${type}`)}
            </option>)}
      </Select2>}
      <QuestionTypeFormFactory question={question} {...rest}/>
      <FormError message={errorMessage} />
      {showRequired && <CheckboxWithLabel
        checked={question.required}
        label={localization.required}
        onChange={e => question.merge({required: e.checked})}
      />}
    </FormLayout>
  );
});

export default QuestionForm;
